import React, {
    useRef,
    useState,
    // useEffect 
} from 'react';
import { useHistory } from 'react-router-dom';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

import { makeStyles } from '@material-ui/core/styles';
// import FormHelperText from '@material-ui/core/FormHelperText';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
// import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';

import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import Logo from '../assets/logo_big_intec.png'
import NewLogo from '../assets/logo_sgi_intec.png'
import Logo_mini from '../assets/logo_mini_intec.png'
import Bg_logo from '../assets/intec_bg_login.jpg'

import { login_gpli, setUserData } from '../services/Api'
import login, { twoFaVerify } from '../services/login'


import userState from '../atoms/user.atom'

import ModalStateLess from '../components/ModalStateLess';


const Styles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    div_root: {
        paddingTop: '10px',
        paddingLeft: "5%",
        paddingRight: "5%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundImage: `url(${Bg_logo})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    },
    form_cad_user: {
        width: "100%"
    },
    form_input: {
        width: "300px"
    },
    form_select: {
        width: "200px"
    },
    btn_submit: {
        marginTop: '20px',
        marginLeft: '0px',
        paddingRight: "25px",
        marginBottom: "20px"
    },
    card: {
        borderRadius: 10,
        paddingTop: 5,
        minWidth: 275,
        color: "#3c5ca6"
    }
}));


const HelpContent = () => {
    return (
        <div>
            <h3 style={{ fontWeight: 'bold' }}>AUTENTICAÇÃO DE 2 FATORES</h3>
            <p style={{ marginTop: 10 }}>
                Para autenticar-se no SGI será necessário ter um aplicativo de autenticação em 2 fatores, como o Google Authenticator, ou o Microsoft Authenticator, após baixar o aplicativo adicione o SGI ao seu atenticador, clicando no link na tela de login ou escaneando o QRCODE, e siga as instruções.
                <p style={{ marginTop: 5, fontWeight: 'bold' }}>
                    OBS: O QRCODE será visivel apenas na primeira tentativa de login, caso não consiga adicionar o SGI ao seu atenticador, entre em contato com o suporte para que seja, realizado o reset da autenticação em 2 fatores.
                </p>
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 20 }} className='space-y-2'>
                <b>Links Google Authenticator</b>
                <a target="_blank" href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=pt_BR' >Android</a>
                <a target="_blank" href='https://apps.apple.com/br/app/google-authenticator/id388497605' >IOS (apple)</a>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 20 }} className='space-y-2'>
                <b>Links Microsoft Authenticator</b>
                <a target="_blank" href='https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=pt_BR' >Android</a>
                <a target="_blank" href='https://apps.apple.com/br/app/microsoft-authenticator/id983156458' >IOS (apple)</a>
            </div>
        </div>
    )
}


function Login({ setToken }) {
    const styles = Styles();

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [qrcode, setQrcode] = useState({ otpAuthUrl: false, qrcode: false, request_token: false })
    const [towFaCode, setTwoFaCode] = useState('')
    const twofaCodeRef = useRef(null)
    const profileUser = useRecoilValue(userState)

    // console.log('profileUser', profileUser)



    const [showHelpModal, setShowHelpModal] = useState(false)

    const set_user = useSetRecoilState(userState)

    const history = useHistory()

    const handleLogin = async () => {
        if (qrcode.otpAuthUrl === false && qrcode.request_token === false) {
            const loginuser = await login(email, password).catch(e => {
                // console.log(e)
                alert(e?.response?.data?.message || 'Verifique os dados e tente novamente.')
            })

            // redirect login data
            if(loginuser.bp === true && loginuser?.sgiUser?.user_glpi){
                set_user({ sgi_data: loginuser.sgiUser })
                history.push('/')
            }

            if (loginuser) {
                const { otpAuthUrl = false, qrCode = false, request_token = false } = loginuser
                if (otpAuthUrl && qrCode) {
                    setQrcode(current => { return ({ ...current, otpAuthUrl, qrcode: qrCode }) })
                } else if (request_token) {
                    setQrcode(current => { return ({ ...current, request_token: true }) })
                }
            }

        } else {
            twoFaVerify(email, password, towFaCode)
                .then(({ sgiUser }) => {
                    // console.log('response from verify', sgiUser)
                    // if (sgiUser?._id) {
                    if (sgiUser?.user_glpi) {
                        set_user({ sgi_data: sgiUser })

                        // const { 
                        //     image_profile, 
                        //     nome, 
                        //     contato, 
                        //     user_glpi, 
                        //     nivel, 
                        //     access_token, 
                        //     tokenjwt,
                        //     desk_permissions
                        // } = sgiUser

                        // set_user({ sgi_data: { 
                        //     image_profile, 
                        //     nome, 
                        //     contato, 
                        //     user_glpi, 
                        //     nivel, 
                        //     access_token, 
                        //     tokenjwt,
                        //     desk_permissions: {
                        //         show_on_menu: desk_permissions.show_on_menu, 
                        //         entrance_option: desk_permissions.entrance_option
                        //     }
                        // } })
                        history.push('/')
                    }
                }).catch(e => {
                    setTwoFaCode('')
                    alert(e?.response?.data?.message || 'Verifique o código e tente novamente.')
                })
        }

    }

    const handle2FaCodeChange = (e) => {
        let value = e.target.value;

        // Remove tudo que não é dígito
        value = value.replace(/\D/g, '');

        // Limita a 6 dígitos
        if (value.length > 6) {
            value = value.slice(0, 6);
        }

        // Aplica o formato: 123 456
        if (value.length > 3) {
            value = `${value.slice(0, 3)} ${value.slice(3, 6)}`;
        }

        setTwoFaCode(value);
    };

    if(profileUser?.sgi_data?.nome){
        window.location.href='/'
    }

    return (
        <div
            className={styles.div_root}
            onKeyUp={async (e) => {
                if (e.keyCode === 13) {
                    // const loginuser = await login(email, password)
                    // // console.log(loginuser)

                    // const { otpAuthUrl, qrCode } = loginuser
                    // if (otpAuthUrl && qrCode) {
                    //     setQrcode({ otpAuthUrl, qrcode: qrCode })
                    // }
                    handleLogin()

                    // if (loginuser.sgi_data !== null) {
                    //     set_user(loginuser)
                    //     history.push('/')
                    // } else {
                    //     alert('Usuário ou senha incorreto, verifique os dados e tente novamente.')
                    // }
                }
            }}
        >
            <ModalStateLess
                show={showHelpModal}
                content={<HelpContent />}
                hideModal={() => {
                    setShowHelpModal(false)
                }}
            />
            <Card style={{ borderRadius: 10 }}>
                <CardContent style={{ textAlign: "center", padding: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{
                        backgroundColor: '#3c5ca6',
                        width: "100%",
                        padding: 8,
                        marginTop: -10,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}
                    >
                        <img
                            alt=""
                            src={Logo_mini}
                            style={{
                                margin: 10,
                                maxHeight: 40
                            }} />
                    </div>
                    <img
                        alt=""
                        src={NewLogo}
                        style={{
                            marginTop: 30,
                            width: 180
                        }} />

                    {(qrcode?.otpAuthUrl === false && qrcode?.request_token === false) &&
                        <form
                            className={styles.form_cad_user}
                            noValidate
                            autoComplete="off"
                            style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30, paddingTop: 30 }}>
                            <div>
                                <TextField
                                    className={styles.form_input}
                                    onChange={e => {
                                        setEmail(e.target.value)
                                    }}
                                    id="usuario"
                                    label="Usuário"
                                />
                            </div>
                            <div>
                                <TextField
                                    className={styles.form_input}
                                    onChange={e => {
                                        setPassword(e.target.value)
                                    }}
                                    type="password"
                                    autoComplete="current-password"
                                    id="password"
                                    label="Senha"
                                />
                            </div>
                            <div>
                                <Button
                                    className={styles.btn_submit}
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={async e => {
                                        handleLogin()
                                        // console.log('loginuser: ', loginuser)
                                        // if (loginuser?.sgi_data !== null) {
                                        //     set_user(loginuser)
                                        //     history.push('/')
                                        // } else {
                                        //     alert('Usuário ou senha incorreto, verifique os dados e tente novamente.')
                                        // }
                                    }}
                                >
                                    Login
                                </Button>
                            </div>
                        </form>
                    }

                    {qrcode.otpAuthUrl !== false &&
                        <div style={{ padding: 30, color: '#3c5ca6' }}>
                            <img src={qrcode.qrcode} alt="QR Code 2FA" className="w-64 mx-auto" />
                            <p className='mt-2'>Escaneie o QrCode com o seu autenticador favorito ou <a style={{ fontWeight: 'bold' }} href={qrcode.otpAuthUrl} >clique aqui</a></p>
                            <p className='mt-2'>Após adicionar o SGI ao seu autenticador preencha o campo abaixo</p>
                        </div>
                    }

                    {(qrcode.otpAuthUrl !== false || qrcode.request_token) &&
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 350, minHeight: 100, padding: 30 }}>
                            <span style={{ margin: 0, padding: 0, fontWeight: 'bold', color: '#3c5ca6' }}>Insira o código de autenticação em dois fatores</span>
                            <input
                                ref={twofaCodeRef}
                                autoFocus={true}
                                className='border rounded placeholder:text-center placeholder:text-md placeholder:align-middle'
                                style={{ width: '100%', padding: 10, marginTop: 5, fontSize: '1.4em', fontWeight: 'bold', color: '#3c5ca6', textAlign: 'center' }}
                                type='text'
                                maxLength={7}
                                placeholder='123 456'
                                onChange={(e) => {
                                    handle2FaCodeChange(e)
                                    // setTwoFaCode(e?.target?.value?.toUpperCase())
                                }}
                                value={towFaCode}
                            // value={(code) => {
                            //     let value = code.replace(/\D/g, ''); // Remove tudo que não é dígito

                            //     if (value.length > 3) {
                            //         value = value.slice(0, 3) + ' ' + value.slice(3, 6);
                            //     }

                            //     return value
                            // }}
                            />
                            <Button
                                className={styles.btn_submit}
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={async e => {
                                    // twoFaVerify(email, password, towFaCode)
                                    // .then(({ sgiUser }) => {
                                    //     console.log('response from verify', sgiUser)
                                    //     if (sgiUser?._id) {
                                    //         set_user({sgi_data: sgiUser})
                                    //         history.push('/')
                                    //     }
                                    // }).catch(e => {
                                    //     setTwoFaCode('')
                                    //     alert(e?.response?.data?.message || 'Verifique o código e tente novamente.')
                                    // })
                                    handleLogin()
                                }}
                            >
                                Enviar
                            </Button>
                        </div>
                    }
                </CardContent>
            </Card>

            <div
                style={{
                    border: '1px solid #fff',
                    position: 'absolute',
                    bottom: 15,
                    right: 15,
                    height: 40,
                    width: 40,
                    borderRadius: "100%",
                    backgroundColor: "#3c5ca6",
                    color: "#fff",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                onClick={() => {
                    setShowHelpModal(true)
                }}
            >
                <span style={{ fontSize: 22, margin: 0 }}>?</span>
            </div>
        </div>
    );
}

export default Login;